import { itx } from "../../translationItx/itx";
import guideSequence_openRoom from "../sequences/guideSequence_openRoom";
import { ToDoItem } from "../ToDoItem";
import StoryLine from "./StoryLine";

export default class StoryLine_Prefixes extends StoryLine {
  static openRoomPrefix(): ToDoItem {
    const room = state.allRooms().filter((room) => !room.isFloorGeneralRoom)[0];
    let text = itx("ToDoItemLine.openRoom").replace("T1", room ? room?.fullTag + " " + room?.name : "");
    if (!room) {
      text = itx("ToDoItemLine.openAndCreateRoom");
    } else if (state.floors.size == 0) {
      text = itx("ToDoItemLine.createFloorAndOpenAndCreateRoom");
    }

    return new ToDoItem({
      id: "openRoom",
      text: text,
      subSteps: undefined,
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;

        let room = state.objectRegistry.getObject(state.activePaneId)?.parent;
        if (room?.className == "Room") {
          res = true;
        }

        return res;
      },
      pattern: guideSequence_openRoom,
      prio: 2,
    });
  }
}
